<template>
  <div class="container">
    <a-modal class="" title="付款类别维护" :visible="categoryVisible" @cancel="closeVisible" width="50%" @ok="submit">
      <div class="containerTop">
        <a-steps :current="type">
          <a-step title="明细字段维护" />
          <a-step title="基础信息维护" />
        </a-steps>
      </div>
      <div class="containerBottom">
          <detailModel></detailModel>

      </div>
    </a-modal>
  </div>
</template>

<script>
import detailModel from './detail.vue'
export default {
  components: {
        detailModel,
    },
  data() {
    return {
      type: 0,
      categoryVisible: false,
    }
  },
  methods: {
    init() {
      this.categoryVisible = true
    },
    //关闭弹窗
    closeVisible() {
      this.categoryVisible = false
    },
    //提交弹窗
    submit() {},
  },
}
</script>

<style>
</style>